import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface RevenueTrend {
  month: string;
  year: number;
  amount: number;
}

export interface GetRevenueTrendParams {
  sessionId: string;
  startDate: string; // yyyy-mm-dd
  endDate: string; // yyyy-mm-dd
  csv?: boolean;
}

export const getRevenueTrendAPI = async ({
  sessionId,
  startDate,
  endDate,
  csv = false,
}: GetRevenueTrendParams) => {
  const response = await baseAPI.get<Array<RevenueTrend> | string>(
    '/dashboard/metrics/revenue-trend',
    {
      params: {
        sessionId,
        startDate,
        endDate,
        csv,
      },
    },
  );
  return response.data;
};

export const useGetRevenueTrend = (params: GetRevenueTrendParams) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.REVENUE_TREND,
      params.sessionId,
      params.startDate,
      params.endDate,
      params.csv,
    ],
    queryFn: () => getRevenueTrendAPI(params),
    enabled: !!params.sessionId && !!params.startDate && !!params.endDate,
  });
};
